// extracted by mini-css-extract-plugin
export var navComponent = "header-module--navComponent--2je38";
export var currentNavComponent = "header-module--currentNavComponent--257FB";
export var mobileMenu = "header-module--mobileMenu--26Bfm";
export var navBar = "header-module--navBar--3POwO";
export var navBarActive = "header-module--navBarActive--3HcrU";
export var container = "header-module--container--E-R4L";